<email-sender-info-card
  #infocard
  [sender]="sender()"
  (authorizeRequested)="handleAuthorizationRequested()"
  (invalidDomainChangeRequested)="scrollToDomain($event)"
></email-sender-info-card>

<div class="domains-header">
  <h3>{{ 'DOMAIN_AUTHORIZATION.GENERAL.HEADER' | translate }}</h3>
  <div>
    {{ 'DOMAIN_AUTHORIZATION.GENERAL.PURPOSE' | translate }}
  </div>
</div>

@if (allDomains$ | glxyAsyncStatus | async; as domains) {
  @switch (domains.status) {
    <!-- Begin state handling -->
    @case ('loaded') {
      <email-domains
        [senderId]="{ senderType: senderType(), senderID: senderID() }"
        [domains]="domains.value"
        [deleteInProgress]="deleting"
        (deleteRequested)="handleDeleteRequested($event)"
        (authorizeRequested)="handleAuthorizationRequested()"
        (useAsDefaultRequested)="infocard.setDomain($event)"
      ></email-domains>
    }
    @case ('empty') {
      <email-domains
        [senderId]="{ senderType: senderType(), senderID: senderID() }"
        [domains]="[]"
        [deleteInProgress]="deleting"
        (deleteRequested)="handleDeleteRequested($event)"
        (authorizeRequested)="handleAuthorizationRequested()"
        (useAsDefaultRequested)="infocard.setDomain($event)"
      ></email-domains>
    }
    @case ('loading') {
      <glxy-loading-spinner></glxy-loading-spinner>
    }
    @case ('error') {
      <glxy-empty-state [size]="'small'">
        <glxy-empty-state-hero>
          <mat-icon color="warn">error</mat-icon>
        </glxy-empty-state-hero>
        <glxy-empty-state-title>{{ 'DOMAIN_AUTHORIZATION.GENERAL.ERROR' | translate }}</glxy-empty-state-title>
        <p>{{ domains.error }}</p>
      </glxy-empty-state>
    }
    <!-- End state handling -->
  }
}
